import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import cssModules from 'react-css-modules'
import Separator from 'components/common/separator'
import { Link } from 'react-router'

import styles from './edit_part.less'

const i18n = getI18n('components/edit_glimpse/edit_part')

class EditPart extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    targetLocation: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onTargetClick: PropTypes.func,
    editButtonDisplay: PropTypes.oneOf([
      'hide',
      'right',
      'bottom',
      'bottom-no-margin',
    ]),
    cancelBottomMargin: PropTypes.bool,
    actionText: PropTypes.string,
    disabled: PropTypes.bool,
    editName: PropTypes.string,
    labelName: PropTypes.string,
  }

  static defaultProps = {
    showEditButton: true,
  }

  render() {
    let containerClass
    switch (this.props.editButtonDisplay) {
      case 'hide':
        containerClass = 'container-no-edit'
        break
      case 'right':
        containerClass = 'container-edit-right'
        break
      case 'right-no-bottom-margin':
        containerClass = 'container-edit-right-no-bottom-margin'
        break
      case 'bottom':
        containerClass = 'container-edit-bottom'
        break
      default:
        containerClass = 'container-edit-right'
    }

    let { actionText } = this.props
    if (!actionText) {
      actionText = i18n('edit')
    }

    return (
      <div>
        <div styleName={containerClass}>
          <div styleName="content">{this.props.children}</div>
          {this.props.editButtonDisplay !== 'hide' && (
            <div styleName="edit-button-container">
              {this.props.targetLocation ? (
                <Link
                  to={this.props.targetLocation}
                  styleName={`edit-button${
                    this.props.disabled ? '-disabled' : ''
                  }`}
                  data-pa-click="edit"
                  data-nemo={`edit-${this.props.editName}`}
                  aria-label={`${actionText} ${this.props.labelName}`}
                >
                  {actionText}
                </Link>
              ) : (
                <a
                  data-pa-click="edit"
                  href="javascript:;"
                  onClick={this.props.onTargetClick}
                  styleName="edit-button"
                  aria-label={`${actionText} ${this.props.labelName}`}
                >
                  {actionText}
                </a>
              )}
            </div>
          )}
        </div>
        <Separator type="dotted" />
      </div>
    )
  }
}

export default cssModules(EditPart, styles)
